import React from 'react';
import Symbol from '../../webcommon/common/symbols/Symbol';
import { createExpanderCell } from '../../webcommon/grid/gridcomponents';

const SensitivtyComponent = createExpanderCell(() => null, undefined, (row, gridProps) => {
    gridProps.onExpanderClick(row);
});

const mappings = [
    {
        id: 'imModel',
        title: 'IM Model',
        expander: true,
        draggable: false,
        hideable: false,
        renderCell: (row) => {
            if (row.original.imModel) {
                if (row.original.children.length) {
                    return <SensitivtyComponent { ...row } value={ row.value || '' } />;
                }
                return row.value || '';
            }
            return '';
        }
    },
    {
        id: 'silo',
        title: 'Silo',
        expander: true,
        draggable: false,
        hideable: false
    },
    {
        id: 'riskClass',
        title: 'Risk Class',
        expander: true,
        draggable: false,
        hideable: false
    },
    {
        id: 'senstivity',
        title: 'Sensitivty Type',
        expander: true,
        draggable: false,
        hideable: false,
        renderCell: (row) => {
            if (row.original.senstivity) {
                if (row.original.children.length) {
                    return <SensitivtyComponent { ...row } value={ row.value || '' } />;
                }
                return row.value || '';
            }
            return '';
        }
    },
    {
        id: 'bucket',
        title: 'Bucket',
        draggable: false,
        hideable: false,
        type: 'number'
    },
    {
        id: 'trades',
        title: 'Trades',
        draggable: true,
        hideable: true,
        type: 'number'
    },
    {
        id: 'imPledgeUsd',
        title: 'IM Pledge',
        draggable: true,
        hideable: true,
        type: 'number',
        Header: header => <Symbol symbol="USD">{header.column.title}</Symbol>,
        symbol: 'USD'
    },
    {
        id: 'imReceiveUsd',
        title: 'IM Receive',
        draggable: true,
        hideable: true,
        type: 'number',
        Header: header => <Symbol symbol="USD">{header.column.title}</Symbol>,
        symbol: 'USD'
    },
    {
        id: 'imPledgeEur',
        title: 'IM Pledge',
        draggable: true,
        hideable: true,
        type: 'number',
        Header: header => <Symbol symbol="EUR">{header.column.title}</Symbol>,
        symbol: 'EUR'
    },
    {
        id: 'imReceiveEur',
        title: 'IM Receive',
        draggable: true,
        hideable: true,
        type: 'number',
        Header: header => <Symbol symbol="EUR">{header.column.title}</Symbol>,
        symbol: 'EUR'
    }
];

export default mappings;
